export default __webpack_public_path__ + "static/media/digital-flare.bd78a334.png";